module.exports = __webpack_public_path__ + "static/media/4.1.510e7f3c.png";